module.exports = __webpack_public_path__ + "img/Kamia_anoxh.f68a35d1.jpg";